"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("./Button"));
var grid_1 = require("./grid");
var FormField_1 = require("./FormField");
var SuccessCheck_1 = __importDefault(require("./SuccessCheck"));
var typography_1 = require("./typography");
var colors_1 = require("../util/colors");
var icons_1 = require("../icons");
var EmailForm = function (_a) {
    var fieldProps = _a.fieldProps, submitText = _a.submitText, confirmationText = _a.confirmationText, onSubmit = _a.onSubmit, _b = _a.repeatable, repeatable = _b === void 0 ? false : _b, _c = _a.wrap, wrap = _c === void 0 ? false : _c;
    var _d = (0, react_1.useState)(), email = _d[0], setEmail = _d[1];
    var _e = (0, react_1.useState)(), error = _e[0], setError = _e[1];
    var _f = (0, react_1.useState)(false), submitted = _f[0], setSubmitted = _f[1];
    var _g = (0, react_1.useState)(false), submitting = _g[0], setSubmitting = _g[1];
    var _h = (0, react_1.useState)(false), wasSubmitted = _h[0], setWasSubmitted = _h[1];
    var submitForm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!email) {
                        setError('Please enter an email address');
                        return [2 /*return*/];
                    }
                    if (!email.match(/\S+@\S+/)) {
                        setError('Invalid email address entered');
                        return [2 /*return*/];
                    }
                    setSubmitting(true);
                    return [4 /*yield*/, onSubmit(email)];
                case 1:
                    error = _a.sent();
                    if (error) {
                        setError(error.message);
                    }
                    else {
                        setSubmitted(true);
                        setError(undefined);
                        setEmail(undefined);
                    }
                    setSubmitting(false);
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (!repeatable)
            return;
        if (!submitted && wasSubmitted)
            setTimeout(function () { return setWasSubmitted(false); }, 295);
        if (submitted && !wasSubmitted) {
            setTimeout(function () { return setWasSubmitted(true); }, 2);
            setTimeout(function () { return setSubmitted(false); }, 2000);
        }
    }, [repeatable, submitted, wasSubmitted, setWasSubmitted]);
    return (react_1.default.createElement(grid_1.Container, { wrap: wrap }, submitted || wasSubmitted ? (repeatable ? (react_1.default.createElement(grid_1.Container, { center: true, p: 1, style: {
            width: '100%',
            transition: 'opacity 0.3s',
            opacity: submitted && wasSubmitted ? 1 : 0,
            backgroundColor: colors_1.colors.green50,
            borderRadius: '4px',
        } },
        react_1.default.createElement(grid_1.Container, { center: true, style: {
                height: '20px',
                width: '20px',
                backgroundColor: colors_1.colors.green500,
                borderRadius: '100%',
            } },
            react_1.default.createElement(icons_1.NewCheck, { scale: 0.75, color: colors_1.colors.white })),
        react_1.default.createElement(typography_1.P, { pl: 1, weight: 500 }, confirmationText))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SuccessCheck_1.default, null),
        react_1.default.createElement(typography_1.P, { pl: 1, fontSize: 1.25 }, confirmationText)))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(FormField_1.FormField, __assign({ field: "email", onChange: function (_a) {
                var value = _a.value;
                return setEmail(value);
            }, error: error, pr: 1.5, pb: wrap ? 2 : 0 }, fieldProps)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Button_1.default, { style: { paddingTop: '10px', paddingBottom: '9px' }, disabled: submitting, onClick: function () { return submitForm(); } }, submitText))))));
};
exports.default = EmailForm;
//# sourceMappingURL=EmailForm.js.map